import { render } from "./top-menu.vue?vue&type=template&id=1f9faf2c&ts=true"
import script from "./top-menu.vue?vue&type=script&lang=ts"
export * from "./top-menu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__